import React, {
  useEffect,
  useReducer,
  useContext,
  useState,
  createContext,
} from 'react';
import { store as mainStore } from '../../../../store';
import { __ } from '../../../../utils/i18n';
import FullCard from '../../../../components/Card/FullCard';
import { initialState, reducer, actions } from './reducer';
import OrdersFilters from './OrdersFilters';
import OrdersList from './OrdersList';
import useTitle from 'hooks/useTitle';

export const store = createContext(null);
const { Provider } = store;

const Orders = ({ config: { name: title } }) => {
  useTitle("سفارشات")
  const { showMessage, showError } = useContext(mainStore);
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <Provider value={{ state, dispatch, actions }}>
      <FullCard className={'pt-1'} divider={false}>
        <OrdersFilters />
        <OrdersList />
      </FullCard>
    </Provider>
  );
};

export default Orders;
